<template>
    <feature-toggle :toggle="enableSplitPromotions">
        <v-btn
            color="primary"
            variant="flat"
            size="x-small"
            :disabled="disabled"
            class="split-promotion-btn"
            @click.stop="$refs.dialog.open()"
        >
            {{ $tkey(`splitPromotion`) }}
        </v-btn>

        <confirm-dialog
            ref="dialog"
            :question-text="$tkey(`confirmationQuestion`, { productCount })"
            :action-text="$t('actions.confirm')"
            :has-activator="false"
            @confirm="confirm"
        />
    </feature-toggle>
</template>

<script>
import { mapActions } from 'vuex';
import featureFlags from '@enums/feature-flags';

const { enableSplitPromotions } = featureFlags;

export default {
    localizationKey: 'splitPromotion',
    props: {
        promotionId: {
            required: true,
            type: String,
        },
        productCount: {
            required: true,
            type: Number,
        },
        disabled: {
            required: true,
            type: Boolean,
            default: false,
        },
    },
    emits: ['split-requested'],
    data() {
        return {
            enableSplitPromotions,
        };
    },
    methods: {
        ...mapActions('promotions', ['queuePromotionForSplitting']),
        async confirm() {
            await this.queuePromotionForSplitting({ promotionId: this.promotionId });
            this.$emit('split-requested');
        },
    },
};
</script>

<style lang="scss" scoped>
.split-promotion-btn :deep(.v-btn__content) {
    color: unset !important;
}
</style>
